export default "__VITE_ASSET__CcKoFdfp__"